import React from 'react'
import UserContainerComponent from '../../components/usersComponents/UserContainerComponent';

function Perfil() {
    return (
        <UserContainerComponent>
            <div className='px-4 lg:px-8'>
                <p>Perfil</p>
            </div>
        </UserContainerComponent>
    )
}

export default Perfil;